import React from "react";
import "./FlowTimeline.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const FlowTimeline = ({flow = [], onOverwrite, connected}) => {
    if (!flow || flow.length === 0) return null;

    // The flow array contains objects like {id: "cupboard", depends_on: [], solved: true}
    const dots = flow.length;
    
    const solveStep = (id) => {
        if (onOverwrite) {
            onOverwrite(id);
        }
    };

    const getLabel = (step) => {
        const text = step.label || step.id.replace(/_/g, ' ');
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    const labelById = Object.fromEntries(flow.map(step => [step.id, getLabel(step)]));

    const minTimelineWidth = Math.max(400, dots * 90);
    const labelWidth = minTimelineWidth / Math.max(1, dots - 1) - 8;

    const mainDiv = (
        <div className="flow-timeline-container">
            <div className="timeline" style={{width: `${minTimelineWidth}px`}}>
                <div 
                    className="timeline-progress" 
                    style={{
                        width: `${Math.min(100, (flow.filter(f => f.solved).length / Math.max(1, flow.length - 1)) * 100)}%`
                    }}
                ></div>
                {flow.map((step, index) => {
                    const isLast = index === flow.length - 1;
                    const leftPosition = isLast ? 100 : (index / (flow.length - 1)) * 100;
                    return (
                        <React.Fragment key={step.id}>
                            <div
                                className="timeline-title"
                                style={{left: `${leftPosition}%`, width: `${labelWidth}px`}}
                            >
                                {getLabel(step)}
                                {step.depends_on && step.depends_on.length > 0 && (
                                    <span className="dependency-info">
                                        ({step.depends_on.map(id => labelById[id] ?? id.replace(/_/g, ' ')).join(', ')})
                                    </span>
                                )}
                            </div>
                            <div
                                className={`timeline-dot ${step.solved ? 'active' : ''}`}
                                style={{left: `${leftPosition}%`}}
                                onClick={() => {
                                    if (!step.solved && window.confirm(`Mark ${step.id} as solved?`)) {
                                        solveStep(step.id);
                                    }
                                }}
                                title={step.solved ? "Solved" : "Click to mark as solved"}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );

    return (
        <RiddleCard 
            mainInfo={mainDiv} 
            layout={"full-size"} 
            title={"Game Flow"} 
            connected={connected}
        />
    );
};

export default FlowTimeline;
